import type { DataForCreateStacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const getDataForCreateStacklet = (): Promise<DataForCreateStacklet> =>
  request({
    url: '/stacklets/data_for_create/',
  });
